import { Chrome } from 'vue-color';
import { ToggleButton } from 'vue-js-toggle-button';
import { VueEditor } from "vue2-editor";
import { Datetime } from 'vue-datetime';
import SectorService from '../../services/Sector.js';
import FeatureLevelService from '../../services/FeatureLevel.js';
import moment from 'moment';

if($('#component-network-editor').length){
    var app = new Vue({
        el: '#component-network-editor',
        data: {
            network:{
                name:'',
                strapline:'',
                description:'',
                network_status_slug:'draft',
                colour:'#FF6965',
                sector_id:'',
                background:"<p>Add a background about your organisation</p>",
                challenge:"<p>Add a full description of your "+type+" and what you're looking for.</p>",
                whats_in_it_for_you:'<p>A successful collaboration could mean, for individuals, becoming part of the wider [INSERT COMPANY NAME] group, while for organisations, forming a potential partnership with one of the world’s most iconic brands to co-develop and co-launch the idea to market.</p><p>These are global challenges and [INSERT COMPANY NAME] are willing to collaborate with both individuals/freelancers and other industry participants/universities etc. and solutions can be at any stage of development.</p><p>If you have or are developing solutions, or if you have expertise in the above, please click "Apply" to submit your solution/expertise to the Network.</p>',
                image_location_file:'',
                image_location:'https://cdn.leadingedgeonly.com/files/platform-images/Mkv33n8JMlxhU413WbL0o7tzA8lp2gsU3xRuQEkp-card.jpg',
                header_banner_image_file:'',
                header_banner_image:'https://'+awsUrl+'/25/D3lcLGDuVhF7pvqqxvozuZSwvgMMoT4Pg5ErFSl3.jpg',
                owner_id:currentUserId,
            },
            account:{
                accountType:{}
            },
            loadingMessage:'Loading '+type+' Editor',
            newUserEmail:'',
            selectedSector: null,
            loading:true,
            nameFocus:false,
            straplineFocus:false,
            descriptionFocus:false,
            challengeFocus:false,
            backgroundFocus:false,
            wiifyFocus:false,
            openColorPicker:false,
            uploaderErrors:[],
            sectors:[],
            networkSlug: networkSlug,
            networkGroupSlug: networkGroupSlug,
            currentUserId: currentUserId,
            type: type,
            showUploadMedia: false,
            dataImages: [],
            targetId: '',
            imageMedia: false,
            bannerMedia: false
        },
        methods: {
            getAccountByUser(){
                axios.get('/api/v1/account/current-user')
                .then((response) =>  {
                    this.account = response.data;
                })
                .catch((error) =>  {
                    if(error.response){
                        this.$toasted.error(error.response.data);
                    }
                    this.loading = false;
                })
            },
            getNetwork(slug){
                axios.get('/api/v1/network/'+slug)
                .then((response) =>  {
                    this.network = response.data;
                    this.account = response.data.account;
                    this.sectorChange();

                    this.$nextTick(function () {
                        this.loading = false;
                        $(".tooltipped").tooltip();
                        this.manualGrow('name');
                        this.manualGrow('strapline');
                        this.manualGrow('description');
                    });
                })
                .catch((error) =>  {
                    this.$toasted.error(error.response.data);
                    this.loading = false;
                })
            },
            saveNetwork(status){
                if(this.validate()){
                    var form =  document.getElementById('editor-preview');
                    var formData = new FormData(form);
                    formData = this.appendFields(formData);
                    formData.append('network_status_slug', status);
                    this.loading = true;
                    this.loadingMessage = 'Saving '+this.type;

                    if ((!this.network.id && !this.network.image_location_file) || this.imageMedia === true) {
                        formData.append('image_location', this.network.image_location.replace("//" + this.awsUrl + "/", ""));
                        this.imageMedia = false;
                    } else if (this.network.image_location_file) {
                        formData.append('image_location', this.network.image_location_file);
                    }
                    if ((!this.network.id && !this.network.header_banner_image_file) || this.bannerMedia === true) {
                        formData.append('header_banner_image', this.network.header_banner_image.replace("//" + this.awsUrl + "/", ""));
                        this.bannerMedia = false;
                    } else if (this.network.header_banner_image_file) {
                        formData.append('header_banner_image', this.network.header_banner_image_file);
                    }

                    axios.post('/api/v1/network/'+this.network.slug, formData)
                    .then((response) =>  {
                        this.getNetwork(this.networkSlug);
                        this.$toasted.success('Your '+this.type+' has been Saved');
                    })
                    .catch((error) =>  {
                        this.$toasted.error(error.response.data);
                        this.loading = false;
                    });
                }
            },
            updateColour(colours){
                this.network.colour = colours.hex;
            },
            sectorChange(){
                var sectorID = this.network.sector_id;
                var sector = this.sectors.filter(obj => {
                    return obj.id === sectorID;
                });
                this.selectedSector = sector[0];
                if(!this.network.id && !this.network.header_banner_image_file){
                    this.network.header_banner_image = sector[0].image_location;
                }
            },
            getSectorSlug(){
                var sectorID = this.network.sector_id;
                var sector = this.sectors.filter(obj => {
                    return obj.id === sectorID;
                });
                return sector[0].slug;
            },
            previewLogoImage(fileBlob, file) {
                if (fileBlob && file) {
                    this.network.image_location = fileBlob;
                    this.network.image_location_file = file;
                    this.showUploadMedia = false;
                    this.saveNetwork(this.network.network_status_slug);
                }
            },
            previewBannerImage(fileBlob, file) {
                if (fileBlob && file) {
                    this.network.header_banner_image = fileBlob;
                    this.network.header_banner_image_file = file;
                    this.showUploadMedia = false;
                    this.saveNetwork(this.network.network_status_slug);
                }
            },
            resetImage(){
                this.network.header_banner_image_file = null;
                $("#header_banner_image").val(null);
                if(this.selectedSector){
                    this.network.header_banner_image = this.selectedSector.image_location;
                }else{
                    this.network.header_banner_image = this.account.header_banner_image;
                }
                this.saveNetwork(this.network.network_status_slug);
            },
            appendFields(formData) {
                formData.append('name', this.network.name);
                formData.append('strapline', this.network.strapline);
                formData.append('description', this.network.description);
                formData.append('colour', this.network.colour);
                formData.append('background', this.network.background);
                if(this.network.challenge == '<p>null</p>' || this.network.challenge == 'null'){
                    this.network.challenge = '';
                }
                formData.append('challenge', this.network.challenge);
                if(this.network.whats_in_it_for_you == '<p>null</p>' || this.network.whats_in_it_for_you == 'null'){
                    this.network.whats_in_it_for_you = '';
                }
                formData.append('whats_in_it_for_you', this.network.whats_in_it_for_you);
                formData.append('header_banner_image_url', this.network.header_banner_image);
                return formData;
            },
            validate(){
                let network = this.network;

                if(!network.name){
                    this.$toasted.error('Your '+this.type+' must have a Name');
                    return false;
                }

                if(!network.description){
                    this.$toasted.error('Your '+this.type+' must have a Description');
                    return false;
                }

                if(!network.colour){
                    this.$toasted.error('Your '+this.type+' must have a Color');
                    return false;
                }

                if(!network.background){
                    this.$toasted.error('You must add a background for your '+this.type);
                    return false;
                }

                return true;
            },
            getTime(time){
                var testDateUtc = moment.utc(time);
                var localDate = testDateUtc.local();
                return localDate.format('LLL');
            },
            autoGrow($event){
                var element = $event.target;
                element.style.height = "5px";
                element.style.height = (element.scrollHeight)+"px";
            },
            manualGrow(name){
                var element = document.getElementById(name);
                element.style.height = "5px";
                element.style.height = (element.scrollHeight)+"px";
            },
            focusEditor(ref){
                this.$nextTick(function () {
                    ref.focus();
                });
            },
            descriptionCheck(){
                if(this.network.description == 'Please add a description'){
                    this.network.description = '';
                }
            },
            backgroundClick(){
                this.backgroundFocus = true;

                if("<p>Add a background about your organisation</p>" == this.network.background){
                    this.network.background = '';
                }

                this.$nextTick(function () {
                    if(this.$refs.background){
                        this.focusEditor(this.$refs.background.quill);
                    }
                });
            },
            challengeClick(){
                this.challengeFocus = true;

                if("<p>Add a full description of your Challenge and what you're looking for.</p>" == this.network.challenge){
                    this.network.challenge = '';
                }

                this.$nextTick(function () {
                    if(this.$refs.challenge){
                        this.focusEditor(this.$refs.challenge.quill);
                    }
                });
            },
            wiifyClick(){
                this.wiifyFocus = true;

                this.$nextTick(function () {
                    if(this.$refs.wiify){
                        this.focusEditor(this.$refs.wiify.quill);
                    }
                });
            },
            uploadMedia(id) {
                this.getUploadedMedia();
                this.targetId = id;
                this.showUploadMedia = true;
            },
            getUploadedMedia() {
                axios.get('/api/v1/get-uploaded-media')
                    .then((response) => {
                        if (response.data.hasOwnProperty('uploads')) {
                            this.dataImages = response.data.uploads;
                        }
                    })
                    .catch((error) => {
                        this.errorHandler(error);
                    })
            },
            onSelectImage(data) {
                if (this.targetId === 'image') {
                    this.network.image_location = data.src;
                    this.imageMedia = true;
                    this.saveNetwork(this.network.network_status_slug);
                } else if (this.targetId === 'banner') {
                    this.network.header_banner_image = data.src;
                    this.bannerMedia = true;
                    this.saveNetwork(this.network.network_status_slug);
                }
                this.showUploadMedia = false;
            },
            selectMethod(result, files) {
                if (result == 'EXTENSION_ERROR') {
                    this.$toasted.error('The selected files contain invalid extensions.');
                    return;
                } else if (result == 'FILE_SIZE_ERROR') {
                    this.$toasted.error('The selected files size exceeded limit.');
                    return;
                }
                if (files && files[0]) {
                    let file = files[0], vm = this, img = new Image();
                    img.onload = function () {
                        if (this.width > 3000 || this.height > 3000) {
                            vm.$toasted.error('The selected image dimensions exceeded limit (3000*3000).');
                        } else {
                            if (vm.targetId === 'image') {
                                vm.previewLogoImage(img.src, file);
                            } else if (vm.targetId === 'banner') {
                                vm.previewBannerImage(img.src, file);
                            }
                        }
                    }
                    img.src = URL.createObjectURL(file);
                }
            }
        },
        mounted () {
            SectorService.getSectors().then(data => {
                this.sectors = data;
            });

            if(this.networkSlug){
                this.getNetwork(this.networkSlug);
            }else{
                this.loading = false;
                this.getAccountByUser();
            }

            $('textarea').keypress(function(event) {
                if (event.keyCode == 13) {
                    event.preventDefault();
                    $(this).blur();
                }
            });
        },
        updated: function () {
        },
        components: {
            'chrome-picker': Chrome,
            'ToggleButton': ToggleButton,
            'vue-editor': VueEditor,
            'SectorService': SectorService,
            'Datetime': Datetime
        },
    });
}